import { ReactNode } from "react";
import { useAuth } from "../../context/AuthContext";
import { useLocation, Navigate, Location } from "react-router-dom";

interface IPrivateRoute {
    children: ReactNode
}

export default function PrivateRoute({ children }: IPrivateRoute) {
    const { isAuthenticated, isLoading } = useAuth();
    const location: Location = useLocation();

    if (isLoading) {
      return <div>Carregando...</div>; // Substitua por um spinner ou indicador visual
    }
    
    if (!isAuthenticated) {
        return <Navigate to="/" state={{ from: location }} replace />;
    }

    return <>{ children }</>;
}